export default __webpack_public_path__ + "static/studio-3-3-5809cdbb070c9365f305f912b7f72e3f.jpg";